<template>
  <div ref="box" v-loading="loading" class="maxwidht order-page">
    <div class="header">确认订单</div>
    <div class="main">
      <div class="content_body">
        <div class="form-group" :class="{'has-error': errors.recipient}">
          <label :style="{'width':labelWidth+'px'}">收货人</label>
          <div class="flex-sub">
            <input type="text" placeholder="请填写收货人姓名" v-model="order.recipient" @blur="validateField('recipient')" />
            <span class="error">{{ errors.recipient }}</span>
          </div>
        </div>
        <div class="form-group" :class="{'has-error': errors.phone}">
          <label :style="{'width':labelWidth+'px'}">联系电话</label>
          <div class="flex-sub">
            <input type="text" placeholder="请填写联系电话" v-model="order.phone" @blur="validateField('phone')" />
            <span class="error">{{ errors.phone }}</span>
          </div>
        </div>
        <div class="form-group" :class="{'has-error': errors.region}">
          <label :style="{'width':labelWidth+'px'}">所在地区</label>
          <div class="flex-sub">
            <input type="text" v-model="order.region" @focus="openSelector" placeholder="选择地区" readonly />
            <span class="error">{{ errors.region }}</span>
          </div>
        </div>
        <div class="form-group" :class="{'has-error': errors.address}">
          <label :style="{'width':labelWidth+'px'}">详细地址</label>
          <div class="flex-sub">
            <input type="text" placeholder="请填写详细地址" v-model="order.address" @blur="validateField('address')" />
            <span class="error">{{ errors.address }}</span>
          </div>
        </div>
        <div class="product">
          <img src="../assets/swiper2.jpg" alt="Product Image" />
          <div class="product-info">
            <h3>【灵多少送多少】福利款欢，畅品头茬新...【灵多少送多少】福利款欢，畅品头茬新...</h3>
            <p>¥69</p>
          </div>
        </div>
        <div class="footer">
          <div class="total">
            共计: ¥69
          </div>
          <div class="payment">
            <label>
              <input type="radio" name="payment" value="wechat" v-model="order.payment" />
              微信支付
            </label>
            <label>
              <input type="radio" name="payment" value="alipay" v-model="order.payment" />
              支付宝支付
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showSelector" class="overlay" @click="closeSelector"></div>
    <div v-if="showSelector" class="selector">
      <div class="header">
        <button @click="closeSelector">关闭</button>
      </div>
      <div class="columns">
        <div class="column">
          <ul>
            <li v-for="province in regions" :key="province.name" @click="selectProvince(province)">
              {{ province.name }}
            </li>
          </ul>
        </div>
        <div class="column" v-if="selectedProvince">
          <ul>
            <li v-for="city in selectedProvince.cities" :key="city.name" @click="selectCity(city)">
              {{ city.name }}
            </li>
          </ul>
        </div>
        <div class="column" v-if="selectedCity">
          <ul>
            <li v-for="district in selectedCity.districts" :key="district" @click="selectDistrict(district)">
              {{ district }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        labelWidth: 65,
        order: {
          recipient: '',
          phone: '',
          region: '',
          address: '',
          payment: 'wechat'
        },
        loading: false,
        selectedRegion: '',
        showSelector: true,
        selectedProvince: null,
        selectedCity: null,
        errors: {
          recipient: null,
          phone: null,
          region: null,
          address: null
        },
        regions: [
                {
                  name: '北京',
                  cities: [
                    {
                      name: '北京市',
                      districts: ['东城区', '西城区', '朝阳区', '海淀区']
                    }
                  ]
                },
                {
                  name: '上海',
                  cities: [
                    {
                      name: '上海市',
                      districts: ['黄浦区', '徐汇区', '长宁区', '静安区']
                    }
                  ]
                },
                {
                  name: '广东',
                  cities: [
                    {
                      name: '广州',
                      districts: ['越秀区', '海珠区', '天河区', '白云区']
                    },
                    {
                      name: '深圳',
                      districts: ['罗湖区', '福田区', '南山区', '宝安区']
                    }
                  ]
                },
                {
                  name: '四川',
                  cities: [
                    {
                      name: '成都',
                      districts: ['锦江区', '青羊区', '金牛区', '武侯区']
                    }
                  ]
                },
                {
                  name: '浙江',
                  cities: [
                    {
                      name: '杭州',
                      districts: ['上城区', '下城区', '江干区', '拱墅区']
                    }
                  ]
                }
              ]
      };
    },
    methods: {
      validateField(field) {
        if (!this.order[field]) {
          this.errors[field] = '此字段是必填项';
        } else {
          this.errors[field] = null;
        }
      },
      openSelector() {
            this.showSelector = true;
          },
          closeSelector() {
            this.showSelector = false;
          },
          selectProvince(province) {
            this.selectedProvince = province;
            this.selectedCity = null;
          },
          selectCity(city) {
            this.selectedCity = city;
          },
          selectDistrict(district) {
            this.selectedRegion = `${this.selectedProvince.name} ${this.selectedCity.name} ${district}`;
            this.closeSelector();
          }
    }
  }
</script>

<style scoped>
  .maxwidht {
    max-width: 500px;
    margin: 0 auto;
  }

  .order-page {
    padding: 20px;
  }

  .header {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    height: 130px;
    color: #fff;
    padding-top: 10px;
    background: linear-gradient(to bottom, #ff5101, #fdfffb);
  }

  .main {
    padding: 10px;
    margin-top: -60px;
  }

  .content_body {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
  }

  .form-group {
    display: flex;
    align-items: baseline;
  }

  .form-group label {
    display: block;
    margin-bottom: 5px;
  }

  .form-group input {
    width: 100%;
    padding: 10px;
    border: none;
    /* border-bottom: 1px solid #ccc; */
    border-radius: 0;
    outline: none;
    box-sizing: border-box;
  }

  .form-group input:focus {
    /* border-bottom: 1px solid #000; */
  }

  .form-group.has-error input {
    border-bottom: 1px solid red;
  }

  .error {
    color: red;
    font-size: 12px;
    margin-top: 5px;
    display: block;
    height: 16px;
  }

  .product {
    display: flex;
    margin-top: 20px;
    margin-bottom: 15px;
  }

  .product img {
    width: 150px;
    height: 150px;
    margin-right: 15px;
  }

  .product-info {
    flex-grow: 1;
  }

  .product-info h3 {
    font-size: 16px;
    margin: 0;
  }

  .product-info p {
    font-size: 18px;
    color: #e91e63;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .total {
    font-size: 18px;
    font-weight: bold;
  }

  .payment {
    display: flex;
  }

  .payment label {
    margin-right: 15px;
  }

  .flex-sub {
    flex: 1;
  }



  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .selector {
    position: fixed;
    bottom: 0;
    max-width: 500px;
    min-width: 500px;
    background: white;
    z-index: 1000;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
  }

  .selector .header {
    display: flex;
    justify-content: flex-end;
    padding: 10px;
  }

  .columns {
    display: flex;
    justify-content: space-around;
  }

  .column {
    width: 33%;
    border-right: 1px solid #ddd;
  }

  .column:last-child {
    border-right: none;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    padding: 15px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }

  li:hover {
    background: #f0f0f0;
  }
</style>



// WEBPACK FOOTER //
// src/components/payPage.vue